import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryCard, CategoryFixState } from './category-fix.state';
import { SageErrorFixStore } from './sage-error-fix.store';

const NAMES_SHOWN = 5;

/** "Category not brought in from Sage yet": one card per Sage category, brought in or linked. */
@Component({
  selector: 'app-category-fix',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './category-fix.component.html',
  styleUrls: ['../onboarding-wizard/sage-wizard.shared.css', '../sage-mockup.shared.css', './fix-section.shared.css'],
})
export class CategoryFixComponent {
  @Input({ required: true }) store!: SageErrorFixStore;
  @Input() syncEnabled = true;
  @Input() idPrefix = '';

  readonly trackCard = (_: number, c: CategoryCard) => c.sageId ?? 'none';

  get state(): CategoryFixState {
    return this.store.categories;
  }

  title(card: CategoryCard): string {
    if (card.state === 'no-category') return 'These items have no category in Sage';
    if (card.state === 'in-aivor' || card.state === 'done') return `"${card.name}" is in Aivor`;
    return `"${card.name}" isn't in Aivor yet`;
  }

  waiting(card: CategoryCard): string {
    const names = card.items.slice(0, NAMES_SHOWN).map((i) => i.name);
    const more = card.items.length - names.length;
    const n = card.items.length;
    return `${n} ${n === 1 ? 'item waits' : 'items wait'} for it: ${names.join(', ')}${more > 0 ? ` and ${more} more` : ''}.`;
  }

  refused(card: CategoryCard) {
    return card.items.filter((i) => i.reason);
  }

  pick(card: CategoryCard, value: string): void {
    this.state.setPick(card, value ? Number(value) : null);
  }
}
